import React from "react";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";

function AboutUs() {
  const { t } = useTranslation("aboutus"); // Load translations from the aboutus namespace

  return (
    <>
      <Helmet>
        <title>{t("page_title")}</title>
        <meta name="description" content={t("meta_description")} />
      </Helmet>

      <div
        className="relative min-h-screen bg-cover bg-center"
        style={{
          backgroundImage: "url('/assets/images/aboutus_bg.jpg')",
        }}
      >
        <div className="absolute inset-0 bg-black opacity-50"></div>

        <div className="relative container mx-auto px-4 py-16 flex flex-col md:flex-row items-center space-y-8 md:space-y-0 md:space-x-12">
          {/* Text Content */}
          <div className="md:w-2/3 bg-white/30 p-8 rounded-xl shadow-2xl backdrop-blur-sm">
            <h2 className="text-4xl font-bold mb-6 text-white border-b-4 border-gold-500 pb-4">
              {t("heading")}
            </h2>

            <div className="space-y-6 text-white">
              <p className="text-lg leading-relaxed">{t("paragraph_1")}</p>
              <p className="text-lg leading-relaxed">{t("paragraph_2")}</p>
              <p className="text-lg leading-relaxed">{t("paragraph_3")}</p>

              <div className="pt-4 border-t border-gray-300 italic text-white/70">
                {t("footer_message")}
              </div>
            </div>
          </div>

          {/* Decorative Diamond Element */}
          <div className="md:w-1/3 flex justify-center">
            <div className="w-64 h-64 bg-white/20 rounded-full flex items-center justify-center backdrop-blur-sm">
              <div className="w-48 h-48 bg-white/30 rounded-full flex items-center justify-center">
                <div className="w-32 h-32 bg-white/50 rounded-full flex items-center justify-center">
                  <div className="w-24 h-24 bg-white rounded-full shadow-2xl"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AboutUs;
